import { getImperativeOverlayApi } from "@app/overlay/imperativeOverlayApi";
import type { OverlayHandle, WindowsApi } from "@app/overlay";
import type { ScannerScanTarget } from "../types";
import { manualBarcodeEntryWindows } from "./manualBarcodeEntry.windows";

/**
 * Открывает blocking-окно ручного ввода штрихкода. \
 * `scanTarget` обязан быть захвачен **до** вызова (пока active entry ещё есть).
 *
 * @param scanTarget цель inject с id регистрации сценария подсказки
 * @returns handle открытого окна
 */
export function openManualBarcodeEntry(scanTarget: ScannerScanTarget): OverlayHandle {
    const overlayApi = getImperativeOverlayApi();
    const windowsApi: WindowsApi = {
        open: (component, props, options) => overlayApi.openWindow(component, props, options),
    };

    return manualBarcodeEntryWindows.main.open(windowsApi, { scanTarget });
}
